<template>
  <div class="right-item">
    <publicItem>
      <publicTitle :title="bottomName"></publicTitle>
      <div class="content">
        <thead style="width: 95%">
          <tr>
            <th>设备名称</th>
            <th>设备类型</th>
            <th>设备型号</th>
            <th>设备状态</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in app" :key="i">
            <td :title="item.title">{{ item.title }}</td>
            <td :title="item.device">{{ item.device }}</td>
            <td :title="item.deviceType">{{ item.deviceType }}</td>
            <td :title="item.details">{{ item.details }}</td>
          </tr>
        </tbody>
      </div>
    </publicItem>
    <publicItem>
      <publicTitle :title="canterName"></publicTitle>
      <div class="content1">
        <div>
          <div id="sleep1" class="zonghe1"></div>
          <div class="tu1">主轴转速</div>
        </div>
        <div>
          <div id="sleep3" class="zonghe2"></div>
          <div class="tu2">进给速度</div>
        </div>
      </div>
    </publicItem>
    <publicItem>
      <publicTitle :title="topName"></publicTitle>
      <div class="content">
        <div id="sleep2" class="zonghe"></div>
      </div>
    </publicItem>
  </div>
</template>

<script>
import publicItem from "./publicItem/publicItem.vue";
import publicTitle from "./publicItem/publicTitle.vue";
import echarts from "echarts";
import { EleResize } from "../js/esresize"; // 导入 echarts 自适应插件
export default {
  components: {
    publicItem,
    publicTitle,
  },
  data() {
    return {
      bottomName: "设备信息",
      canterName: "饼图",
      topName: "设备本月OEE图",
      app: [
        {
          title: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
          device: "xxxxxxxx",
          deviceType: "xxxxxxxx",
          details: "xxxxxxxx",
        },
        {
          title: "xxxxxxxx",
          device: "xxxxxxxx",
          deviceType: "xxxxxxxx",
          details: "xxxxxxxx",
        },
        {
          title: "xxxxxxxx",
          device: "xxxxxxxx",
          deviceType: "xxxxxxxx",
          details: "xxxxxxxx",
        },
        {
          title: "xxxxxxxx",
          device: "xxxxxxxx",
          deviceType: "xxxxxxxx",
          details: "xxxxxxxx",
        },
        {
          title: "xxxxxxxx",
          device: "xxxxxxxx",
          deviceType: "xxxxxxxx",
          details: "xxxxxxxx",
        },
        {
          title: "xxxxxxxx",
          device: "xxxxxxxx",
          deviceType: "xxxxxxxx",
          details: "xxxxxxxx",
        },
        {
          title: "xxxxxxxx",
          device: "xxxxxxxx",
          deviceType: "xxxxxxxx",
          details: "xxxxxxxx",
        },
        {
          title: "xxxxxxxx",
          device: "xxxxxxxx",
          deviceType: "xxxxxxxx",
          details: "xxxxxxxx",
        },
        {
          title: "xxxxxxxx",
          device: "xxxxxxxx",
          deviceType: "xxxxxxxx",
          details: "xxxxxxxx",
        },
      ],
    };
  },

  mounted() {
    this.select2();
    // this.select1();
  },
  methods: {
    select2() {
      let select2 = echarts.init(document.getElementById("sleep2"));
      let select1 = echarts.init(document.getElementById("sleep1"));
      let select3 = echarts.init(document.getElementById("sleep3"));
      // 柱状图
      let option = {  
        grid: {
          left: '10%',
          right: '5%',
          top: '10%',
          bottom: '16%',
        },
        textStyle: {
          fontSize: 0,
        },
        tooltip: {},
        xAxis: {
          nameTextStyle: {
            color: "#c0c3cd",
            padding: [0, 0, -10, 0],
            fontSize: 4,
          },
          axisLabel: {
            color: "#8db7b5", //X轴文字
            fontSize: 10,
            interval: 0,
          },
          axisTick: {
            lineStyle: {
              color: "#0B1535",
              width: 1,
            },
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#384267",
              width: 1,
              type: "dashed",
            },
            show: true,
          },

          data: [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
            20, 21,
          ],
        },
        yAxis: {
          type: "value",
          nameTextStyle: {
            color: "#c0c3cd",
            padding: [0, 0, -10, 0],
            fontSize: 8,
          },
          axisLabel: {
            color: "#8db7b5", //Y轴文字
            fontSize: 10,
          },
          axisTick: {
            lineStyle: {
              color: "#384267",
              width: 1,
            },
            show: true,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#384267",
              type: "line",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#fff",
              width: 2,
              type: "line",
            },
            show: false,
          },
        },
        series: [
          {
            data: [
              75, 82, 65, 68, 50, 60, 48, 52, 60, 60, 55, 65, 70,
              55, 65, 40, 30, 60, 40, 35, 50,
            ],
            type: "bar",
            barWidth: 6,
            itemStyle: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,

                colorStops: [
                  {
                    offset: 0,
                    color: "#01cdc6",
                  },
                  {
                    offset: 1,
                    color: "#0B1A39",
                  },
                ],
              },
            },
            label: {
              show: false,
              position: "top",
              distance: 2,
              color: "#fff",
              position: [30, 10],
            },
          },
          // {
          //   data: [0, 0, 0],
          //   type: "pictorialBar",
          //   barMaxWidth: "0",
          //   symbol: "diamond",
          //   symbolOffset: [0, 0],
          //   symbolSize: [30, 15],
          // },
        ],
      };
      // 饼图
      var dataArr = 187;
      var colorSet = {
        color: "#468EFD",
      };
      let option1 = {
        grip: {
          left: "0%",
          right: "",
          top: "",
          bottom: "",
          width: "100%",
        },
        tooltip: {
          formatter: "{a} <br/>{b} : {c}%",
        },
        series: [
          {
            name: "外部线",
            type: "gauge",
            radius: "75%", // 动态
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              lineStyle: {
                color: [
                  [1, "#278787"], // 动态
                ],
                width: 1,
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            detail: {
              show: false,
            },
            title: {
              //标题
              show: false,
            },
          },
          {
            name: "外部刻度",
            type: "gauge",
            radius: "75%",
            min: 0, //最小刻度
            max: 200, //最大刻度
            splitNumber: 1, //刻度数量
            startAngle: 450,
            endAngle: -45,
            axisLine: {
              show: false,
              lineStyle: {
                color: [[1, "rgba(0,0,0,0)"]],
              },
            }, //仪表盘轴线
            axisLabel: {
              show: false,
              color: "#a10833",

              distance: -20, // 动态
            }, //刻度标签。
            axisTick: {
              show: false,
            }, //刻度样式
            splitLine: {
              show: false,
            },
          },
          {
            name: "内部宽线条",
            type: "gauge",
            radius: "15%",
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              lineStyle: {
                color: [[1]],
                width: 10,
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            detail: {
              show: false,
            },
            title: {
              show: false,
            },
          },
          {
            name: "内部细线条",
            type: "gauge",
            radius: "56%",
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              lineStyle: {
                color: [[1, "#278787"]],
                width: 1,
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            detail: {
              show: false,
            },
            title: {
              show: false,
            },
          },
          {
            name: "间隔条形",
            type: "gauge",
            radius: "70%",
            z: 4,
            splitNumber: 35,
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              lineStyle: {
                opacity: 0,
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: true,
              length: 10,
              splitNumber: 1,
              lineStyle: {
                color: "#278787",
                width: 1,
              },
            },
            splitLine: {
              show: false,
            },
            detail: {
              show: false,
            },
            title: {
              show: false,
            },
          },
          {
            name: "数据",
            type: "gauge",
            radius: "70.5%",
            z: 2,
            startAngle: 225,
            max: 200,
            endAngle: -45,
            axisLine: {
              lineStyle: {
                color: [
                  [dataArr / 200, "#31F3FF"], // 动态
                  [1, "#185363"],
                ],
                width: 10,
              },
            },

            axisLabel: {
              show: false,
            },

            splitLine: {
              show: false,
            },
            detail: {
              show: true,
              fontWeight: "bold",
              fontSize: 15,
            },
            data: [
              {
                name: "",
                value: dataArr,
              },
            ],
          },
          // 内圆
          {
            name: "内圆环",
            type: "pie",
            radius: ["4%", "2%"],
            hoverAnimation: false,
            tooltip: {
              show: false,
            },

            labelLine: {
              normal: {},
            },
          },
          // 内圆
          {
            name: "内圆环2",
            type: "pie",
            radius: "1%",
            hoverAnimation: true,
            cursor: "default",
            tooltip: {
              show: true,
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
          },
        ],
      };

      var dataArr = 187;
      var colorSet = {
        color: "#468EFD",
      };
      let option2 = {
        grip: {
          left: "0%",
          right: "",
          top: "",
          bottom: "",
        },
        tooltip: {
          formatter: "{a} <br/>{b} : {c}%",
        },
        series: [
          {
            name: "外部线",
            type: "gauge",
            radius: "75%", // 动态
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              lineStyle: {
                color: [
                  [1, "#278787"], // 动态
                ],
                width: 1,
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            detail: {
              show: false,
            },
            title: {
              //标题
              show: false,
            },
          },
          {
            name: "外部刻度",
            type: "gauge",
            radius: "75%",
            min: 0, //最小刻度
            max: 200, //最大刻度
            splitNumber: 1, //刻度数量
            startAngle: 450,
            endAngle: -45,
            axisLine: {
              show: false,
              lineStyle: {
                color: [[1, "rgba(0,0,0,0)"]],
              },
            }, //仪表盘轴线
            axisLabel: {
              show: false,
              color: "#a10833",

              distance: -20, // 动态
            }, //刻度标签。
            axisTick: {
              show: false,
            }, //刻度样式
            splitLine: {
              show: false,
            },
          },
          {
            name: "内部宽线条",
            type: "gauge",
            radius: "15%",
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              lineStyle: {
                color: [[1]],
                width: 10,
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            detail: {
              show: false,
            },
            title: {
              show: false,
            },
          },
          {
            name: "内部细线条",
            type: "gauge",
             radius: "56%",
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              lineStyle: {
                color: [[1, "#fcbf01"]],
                width: 1,
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            detail: {
              show: false,
            },
            title: {
              show: false,
            },
          },
          {
            name: "间隔条形",
            type: "gauge",
            radius: "70%",
            z: 4,
            splitNumber: 35,
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              lineStyle: {
                opacity: 0,
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: true,
              length: 10,
              splitNumber: 1,
              lineStyle: {
                color: "#278787",
                width: 1,
              },
            },
            splitLine: {
              show: false,
            },
            detail: {
              show: false,
            },
            title: {
              show: false,
            },
          },
          {
            name: "数据",
            type: "gauge",
            radius: "70.5%",
            z: 2,
            startAngle: 225,
            max: 200,
            endAngle: -45,
            axisLine: {
              lineStyle: {
                color: [
                  [dataArr / 200, "#fcbe00"], // 动态
                  [1, "#185363"],
                ],
                width: 10,
              },
            },

            axisLabel: {
              show: false,
            },

            splitLine: {
              show: false,
            },
            detail: {
              show: true,
              fontWeight: "bold",
              fontSize: 15,
            },
            data: [
              {
                name: "",
                value: dataArr,
              },
            ],
          },
          // 内圆
          {
            name: "内圆环",
            type: "pie",
            radius: ["4%", "2%"],
            hoverAnimation: false,
            tooltip: {
              show: false,
            },

            labelLine: {
              normal: {},
            },
          },
          // 内圆
          {
            name: "内圆环2",
            type: "pie",
            radius: "1%",
            hoverAnimation: true,
            cursor: "default",
            tooltip: {
              show: true,
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
          },
        ],
      };
      select2.setOption(option);
      select1.setOption(option1);
      select3.setOption(option2);
      // window.onresize = function(){ // js 的窗口变化方法
      //   select1.resize() // echartys 自带自适应的函数
      //   select2.resize()
      //   select3.resize()
      // }
       // 自适应
      let listener1 = function () {
        select1.resize();
      };
      EleResize.on(document.getElementById("sleep1"), listener1);
       // 自适应
      let listener2 = function () {
        select2.resize();
      };
      EleResize.on(document.getElementById("sleep2"), listener2);
       // 自适应
      let listener3 = function () {
        select3.resize();
      };
      EleResize.on(document.getElementById("sleep3"), listener3);
    },
  },
};
</script>
<style scoped>
.right-item {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.content {
  width: 100%;
  height: 100%;
  font-size: 0.8vw;
}
/*  */
.content1 {
  width: 100%;
  height: 92%;
  display: flex;
  overflow: hidden;
  font-size: 0.8vw;
}
.content1 > div {
  width: 50%;
  height: 100%;
}
/* 饼图一 */
.zonghe1 {
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
  /* right: 100px; */
}
/* 饼图二 */
.zonghe2 {
  width: 100%;
  height: 100%;
  /* height: 100%;
  overflow: hidden;
  bottom: 232px;
  left: 100px; */
}
.title-bottom {
  background: url("../assets/image/ab_title_bottom_bj.png") no-repeat;
  margin: 1.1vh 0;
  width: 100%;
  height: 2px;
  background-size: 100% 100%;
  position: absolute;
  top: 40px;
  display: flex;
}
.content-bottom {
  width: 100%;
  height: 92%;
  /* overflow: auto; */
  overflow: hidden;
}

thead {
  /* width: calc(100% - 3%); */
  height: 10%;
}
thead,
tbody tr {
  display: table;
  width: 100%;
  min-height: 35px;
  table-layout: fixed;
  text-align: center;
  font-size: 1.3rem;
}
tbody td {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
thead,
tbody tr th {
  color: #008d88;
  font-size: 10px;
}
tbody::-webkit-scrollbar {
  display: block;
}
tbody tr:nth-child(odd) {
  /* height: 10%; */
  background-color: rgba(61, 85, 94, 0.3);
}
tbody {
  height: 80%;
  display: block;
  overflow-y: scroll;
}
.zonghe {
  width: 100%;
  height: 100%;
  /* bottom: 30px; */
}
.tu1 {
  width: 28%;
  height: 4%;
  position: absolute;
  left: 12%;
  bottom: 38%;
  text-align: center;
  line-height: 57px;
  background-image: url("../assets/image/echart-span1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  right: 30px;
}
.tu2 {
  width: 28%;
  height: 4%;
  position: absolute;
  left: 62%;
  bottom: 38%;
  text-align: center;
  line-height: 57px;
  background-image: url("../assets/image/echart-span.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  right: 30px;
}
</style>